import { smb_fetch, getAgsApiUrl } from '@/api/operator/fetch';

// 获取热点号码
export const getHotLinePhone = (data: any = {}) => {
  const url = getAgsApiUrl('v2', 'call-center/hotlinephone-search');
  return smb_fetch(url, {
    method: 'GET',
    data,
  }, false, false);
};
